export default {
  namespaced: true,
  actions: {
  name: "Acción | Acciones",
  accept: "Aceptar",
  add: "Agregar",
  edit: "Editar",
  delete: "Eliminar",
  cancel: "Cancelar",
  filter: "Filtro | Filtros",
  update: "Actualizar",
  export: "Exportar",
  close: "Cerrar",
  save: "Guardar",
  save_changes: "Guardar cambios",
  send: "Enviar",
  download: "Descargar",
  reset: "Resetear",
  drag_drop_1: "¡Arrastra y suelta para subir contenido!",
  drag_drop_2: "...o haga clic para seleccionar un archivo de su computadora",
  load: "Cargar",
  refresh: "Refrescar",
  next: "Siguiente",
  previous: "Anterior",
  go_back: "Regresar",
  finish: "Terminar",
  delete_all: "Eliminar todos",
  select_deselect_all: "Seleccionar/Deseleccionar todo",
  validate: "Validar",
  sync: "Sincronizar",
  synchronizing: "Sincronizando",
  showMore: "Ver mas",
  clone: "Clonar",
  show: "Mostrar",
  refresh_table: "Refrescar Tabla",
  collapse: "Colapsar",
  expand: "Expandir",
  start: "Iniciar",
  stop: "Detener",
  pause: "Pausar",
  approve: "Aprobar",
  reject: "Rechazar",
  status: "Estado",
  exit: "Salir",
  syncing: "Sincronizando",
  saving: "Guardando",
  loading: "Cargando",
  view_document: "Visualizar documento",
  search: "Buscar",
  download_document: "Descargar documento",
  file_upload: {
    accepted_types_label: "Tipos aceptados:",
    accepted_types_value: "Imágenes, PDF, Word, Excel, PowerPoint.",
    max_label: "Máximo:",
    max_per_document: "30 MB por documento",
    max_documents_total: "5 documentos en total",
    tooltip: "Imágenes: JPG, JPEG, PNG, GIF, BMP, WEBP, SVG<br>Documentos: PDF<br>Word: DOC, DOCX, ODT, RTF<br>Excel: XLS, XLSX, CSV, ODS",
    select_files: "Seleccionar archivos...",
    browse: "Examinar",
    max_documents_error: "Máximo {n} documentos permitidos",
    max_size_error: "{name}: excede el tamaño máximo de {n} MB",
    uploading: "Subiendo archivo(s)...",
    deleting: "Eliminando archivo...",
  },
  },
};
